// extracted by mini-css-extract-plugin
export var text = "_74-0";